var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc"},[_vm._m(0),_c('div',{ref:"cmain1",staticClass:"cmain"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lt-left"},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"bg1 rotateXZ-element imgdealy2"}),_c('div',{staticClass:"bg2 rotateXZ-element"}),_c('div',{staticClass:"bg3"})])
}]

export { render, staticRenderFns }